<!--<h3>{{ 'dataTransformations.searchTransformations' | translate }}</h3>-->
<div class="row fields-group">
    <div class="col">
        <label for="group-by-function" class="d-block list-title">{{ "Select groupBy function" | translate }}</label>
        <select id="group-by-function" class="d-flex w-100 form-control" [(ngModel)]="typeTransformation" (change)="typeUpdate()">
            <option value="">Function</option>
            <option value="sumBy">{{"Sum" | translate}}</option>
        </select>
    </div>
</div>
